export enum VisualisationType {
    Chart = 'chart',
    Markdown = 'markdown',
    Table = 'table',
    Text = 'text',
}
